if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const sectionKeysToMirror = ['_add_source','section-id', 'sections_url', 'sections'];

      // sectionKeysToMirror.forEach(key => {
      //   const value = formData.get(key);
      //   if (value) {
      //     let propName = `properties[_${key.replace('-', '_')}]`;
      //     if (!formData.has(propName)) {
      //       formData.append(propName, value);
      //     }
      //   }
      // });


      const variantId = formData.get('id');
      let currentSku = null;

      // 1. 获取原始字符串 "id:sku;id:sku"
      const rawSkus = this.form.dataset.skus;

      if (rawSkus && variantId) {
        // 2. 拆分字符串
        // 格式: "123:A;456:B" -> ["123:A", "456:B"]
        const pairs = rawSkus.split(';');
        
        // 3. 查找匹配的 ID
        for (let i = 0; i < pairs.length; i++) {
          const parts = pairs[i].split(':'); // parts[0] is ID, parts[1] is SKU
          if (parts[0] === variantId) {
            currentSku = parts[1]; // 找到了！
            break; // 停止循环
          }
        }
      }

      // 4. 如果找到了 SKU，且全局预售配置存在
      if (currentSku && window.getBackorderInfo) {
        
        // 获取当前国家
        const country = window.Shopify && window.Shopify.country ? window.Shopify.country : 'US';
        
        // 查询全局配置 (BackorderMap)
        const info = window.getBackorderInfo(currentSku, country);
        
        if (info) {
           // 命中预售！
           
           // 🔥 核心修改：优先级判断逻辑 🔥
           let labelKey = "⏳ Preorder"; // 默认情况

           if (info.isUpgrade) {
             // 优先级 1: 免费升级
             labelKey = "✨ Free Upgrade";
           } else if (info.isBundle) {
             // 优先级 2: 套装分拆发货
             labelKey = "🔥 Split Ship";
           }
           // 优先级 3: 保持默认 "⏳ Preorder"

           // 注入属性
           formData.append(`properties[${labelKey}]`, info.msg);
           formData.append(`properties[_preorder_data]`, info.msg);
           
           // 保留你添加的市场标记
           formData.append(`properties[_Market]`, country );
        }
      }

      const prepareCartItemsEvent = new CustomEvent('on:product-form:prepare-cart-items', {
        bubbles: true,
        detail: {
          formData,
          items: null,
          primaryVariantId: Number(variantId),
          beforeAdd: null,
          afterAdd: null
        }
      });
      this.form.dispatchEvent(prepareCartItemsEvent);

      const afterAtc = this.form.dataset.afterAtc === 'stay' ? 'stay' : theme.settings.afterAtc;

      const preparedItems = prepareCartItemsEvent.detail.items;
      const primaryVariantId = prepareCartItemsEvent.detail.primaryVariantId || Number(variantId);

      const fetchRequestOpts = preparedItems ? {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: preparedItems,
          sections_url: window.location.pathname,
          sections
        })
      } : {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      let cancelled = false;
      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const beforeAdd = prepareCartItemsEvent.detail.beforeAdd;
        if (typeof beforeAdd === 'function' && await beforeAdd(oldCartData) === false) {
          cancelled = true;
          return;
        }

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        const afterAdd = prepareCartItemsEvent.detail.afterAdd;
        if (typeof afterAdd === 'function') await afterAdd(data);

        if (afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const primaryAddedItem = preparedItems
          ? data.items?.find((item) => item.variant_id === primaryVariantId)
          : data;
        const addedQuantity = primaryAddedItem?.quantity || preparedItems?.[0]?.quantity || data.quantity;
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === primaryVariantId
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: primaryVariantId,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === addedQuantity)
                ? itemInOldCart.quantity : addedQuantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: primaryVariantId
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        if (cancelled) {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-disabled');
        } else {
          // Re-enable 'Add to Cart' button.
          this.submitBtn.classList.add('is-success');
          this.submitBtn.removeAttribute('aria-disabled');
          setTimeout(() => {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
          }, 1400);
        }
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
